/**
 * @generated SignedSource<<459ebdc831022d1feb81545d47568290>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DynamicImageDisplayComponent_PodcastWithTimestampElementFragment$data = {
  readonly timestampsWithImage: ReadonlyArray<{
    readonly end: number;
    readonly imageFile: {
      readonly url: string | null;
    } | null;
    readonly start: number;
  }>;
  readonly " $fragmentType": "DynamicImageDisplayComponent_PodcastWithTimestampElementFragment";
};
export type DynamicImageDisplayComponent_PodcastWithTimestampElementFragment$key = {
  readonly " $data"?: DynamicImageDisplayComponent_PodcastWithTimestampElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DynamicImageDisplayComponent_PodcastWithTimestampElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DynamicImageDisplayComponent_PodcastWithTimestampElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimestampWithImage",
      "kind": "LinkedField",
      "name": "timestampsWithImage",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "imageFile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PodcastWithTimestampLearnElement",
  "abstractKey": null
};

(node as any).hash = "d8a73aa195686b5eeb12e68c34bfa594";

export default node;
